import configfile from '../../config/config'
let config = configfile.config
import { generateApiURL } from "./index.js";

export default {
  methods: {
    getUserMail (token) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphuserapi + '/mailFolders/Inbox/messages?$filter=isRead ne true&$count=true')
    },
    getUserPhoto (token) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphuserapi + '/photo/$value', { responseType: 'blob' })
    },
    getUserProfile (token) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphuserapi)
    },
    getFilterDate (days) {
      const date = this.$moment().subtract(days, 'days').format('YYYY-MM-DD')
      return "&$filter=fields/Created gt '" + date + "T00:00:00Z'"
    },
    getFilterCategory (category) {
      return "&$filter=fields/Category eq '" + category + "'"
    },
    getEIPNewsList (token, days) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint.eipsite_id + '/lists/' + config.pilotportal['news_list'] + '/items?expand=fields(select=Title,Body,Thumbnail)' + this.getFilterDate(days))
    },
    getCrewPortalNewsList (token, days) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint.pilotportalsite_id + '/lists/' + config.pilotportal['cabincrewnews_list'] + '/items?expand=fields(select=Title,Body,Thumbnail)' + this.getFilterDate(days))
    },
    getList (token, site, listName, filter) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + site + '/lists/' + listName + '/items?expand=fields(select=Title,Body,Thumbnail)' + filter)
    },
    getNoticeList (token) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint.pilotportalsite_id + '/lists/' + config.pilotportal['notice_list'] + '/items?expand=fields(select=Title,id)')
    },
    getAdminList (token) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint.pilotportalsite_id + '/lists/' + config.pilotportal['admin_list'] + '/items?expand=fields(select=id, Title, Role)')
    },
    getPilotConnectList (token) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/lists/' + config.pilotportal['crewconnect_list'] + '/items?expand=fields(select=Title, Tel, Email, Priority)')
    },
    getDetail (token, site, listName, id) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + site + '/lists/' + listName + '/items/' + id + '/?expand=fields(select=Title,Body,Created,Attachments)')
    },
    getCrewPortalDocumentList (token) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal['elibrary_id'] + '/root/children')
    },
    getCategory (token, site, listName) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + site + '/lists/' + listName + '/items?expand=fields(select=Category)')
    },
    getPilotPortalDocumentFile (token, foldername) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      // return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal[foldername + '_id'] + '/root/children')
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal[foldername + '_id'] + '/root/children?expand=listItem')
    },
    getPilotBulletinFile (token, foldername) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal['bulletin_id'] + '/root:/' + foldername + ':/children?expand=listItem')
    },
    getPilotD3Folder (token, foldername, dynamicfolder, selectfolder) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal[foldername + '_id'] + '/root:/' + dynamicfolder + '/' + selectfolder + ':/children')
    },
    getPilotD2Folder (token, foldername, dynamicfolder) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal[foldername + '_id'] + '/root:/' + dynamicfolder + ':/children')
    },
    getPilotD1Folder (token, foldername) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal[foldername + '_id'] + '/root/children')
    },
    getPilotD3File (token, foldername, dynamicfolder, selectfolder, lastfolder) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal[foldername + '_id'] + '/root:/' + dynamicfolder + '/' + selectfolder + '/' + lastfolder + ':/children')
    },
    getPilotD2File (token, foldername, dynamicfolder, selectfolder) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal[foldername + '_id'] + '/root:/' + dynamicfolder + '/' + selectfolder + ':/children')
    },
    getPilotD1File (token, foldername, dynamicfolder) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/drives/' + config.pilotportal[foldername + '_id'] + '/root:/' + dynamicfolder + ':/children')
    },
    getRadiation(token, emplEmail) {
      const data = { emplEmail };
      return this.$axios({
        url: `${generateApiURL("/radiationapi")}`,
        method: "POST",
        headers: { Authorization: token },
        data
      });
    },
    postNextDuty (token, userEmail) {
      return this.$axios({
        url: '/nextdutyapi/',
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
          'Authorization': token
        },
        data: '{"emplEmail":"' + userEmail + '"}'
      })
    },
    getDutyDetail (token, listName, titleName) {
      this.$axios.defaults.headers.common['Authorization'] = `${token}`
      return this.$axios.get(config.graphapi + config.sharepoint['pilotportalsite_id'] + '/lists/' + listName + "/items?expand=fields(select=Title,Body,Attachments)&$filter=fields/Title eq '" + titleName + "'")
    },
    getAccessToken (code) {
      const form = new FormData()
      form.append('grant_type', config.token['grant_type'])
      form.append('client_id', config.token['client_id'])
      form.append('client_secret', config.token['client_secret'])
      form.append('scope', config.token['scope'])
      form.append('code', code)

      return this.$axios({
        url: '/tokenapi/' + config.token['tenant_id'] + '/oauth2/v2.0/token',
        method: 'POST',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        },
        data: form
      })
    },
    getLeaveDetail (userEmail) {
      return this.$axios({
        url: '/leaveapi/',
        // url: 'https://ehrms-uat.starlux-airlines.com/api/getEmployeeAllLeaveEIP',
        method: 'GET',
        params: {
          'email': userEmail,
          'year': this.$moment().format('YYYY')
        }
      })
    },
    getBusType() {
      return this.$axios.get('/JXStarwalker/GetBusType', {
        headers: { Authorization: `Bearer ${config.token.bus_id}` },
      });
    },
    getBusStation() {
      return this.$axios.get('/JXStarwalker/GetStation', {
        headers: { Authorization: `Bearer ${config.token.bus_id}` },
      });
    },
    getBusTimeData(data) {
      return this.$axios.post('/JXStarwalker/QueryTimeTable', data, {
        headers: { Authorization: `Bearer ${config.token.bus_id}` },
      });
    },
    getBusNotice() {
      return this.$axios.get('/JXStarwalker/GetNoteContent', {
        headers: { Authorization: `Bearer ${config.token.bus_id}` },
      });
    }
  }
}
